import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils/applicationContext';
import { PageContainer, PageContainerMobile } from '../PageContainer';
import { Responsive } from '@cian/ui-kit';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { deviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={deviceType}>
          <Provider store={reduxStore}>
            <Responsive desktop>
              <PageContainer />
            </Responsive>
            <Responsive tablet phone>
              <PageContainerMobile />
            </Responsive>
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
